<template>
    <el-drawer class="w-el-drawer" :visible.sync="visible" :size="960" :with-header="false" direction="rtl" :before-close="Close" append-to-body destroy-on-close>   
        <div class="w-el-drawer-header">
            <i class="el-icon-tickets"></i> {{ lable }}
        </div>
        <div class="w-el-drawer-body">
            <froala-editor v-model="event_explain" />
        </div>
        <div class="w-el-drawer-footer">
            <el-button size="medium" @click="Close()">取消 / 返回</el-button>
            <el-button size="medium" type="primary" @click="ProjectsStatusChange()" :loading="loading">确认变更</el-button>
        </div>
    </el-drawer>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
            loading: false,
            lable: null,
            id: null,
            status: null,
            event_explain: null,
        }
    },
    methods: {
        Open(id, status) {
            switch(status) {
                case 1:
                    this.lable = '开始项目'
                    break;
                case 2:
                    this.lable = '暂停/挂起项目'
                    break;
                case 4:
                    this.lable = '关闭项目'
                    break;
                case 5:
                    this.lable = '转待验收'
                    break;
                default:
                    this.Close()
                    break;
            }
            this.id = id
            this.status = status
            this.visible = true
        },
        Close() {
            this.id = null
            this.status = null
            this.event_explain = null
            this.visible = false
            this.loading = false
        },
        ProjectsStatusChange() {
            this.loading = true
            this.$http.post('/9api/projects/status-change', { id: this.id, status: this.status, event_explain: this.event_explain }).then(rps => {
                this.$notify.success({
                    title: '提示',
                    message: rps.data.success,
                    duration: 2000
                })
                this.$emit("success")
                this.Close()
            })
        }
    }
}
</script>